import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ISSUES } from '../../../../webcomponents.constants';
import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { HealthDashboardEndpointIssuesStrings, InsightsTemplatesStringKeys } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ISSUES)
export class GzHealthDashboardEndpointIssuesWebComponent extends GzHealthDashboardInsights {
  widgetKey = 'endpointIssues';

  changedInfoBoxText = `
          ${translateFn('You have <b>updates</b> for this widget!')}
          <br />
          <br />
          ${translateFn(
            'To experience the latest design, close the current widget and select the new ones in the Settings panel. Apply your changes and save the view.'
          )}`;

  strings: HealthDashboardEndpointIssuesStrings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.ENDPOINT_SECURITY_ISSUES,
        title: translateFn('Important security issues'),
        items: [
          // TODO RE-ENABLE WHEN ENDPOINT SENDS THIS STATUS
          //{
          //  key: 'notScanned',
          //  name: translateFn('Unscanned in the last <x> days'),
          //  tooltipText: 'No full scan was performed in the last <x> days.',
          //  severity: WidgetSectionItemSeverity.WARNING,
          //},
          {
            key: InsightsTemplatesStringKeys.UNSOLVED_MALWARE_DETECTIONS,
            name: translateFn('Unresolved malware detections'),
            tooltipText: translateFn('Endpoints may require a system restart to complete the disinfection process.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
          {
            key: InsightsTemplatesStringKeys.SETTINGS_CHANGED_WITH_POWER_USER,
            name: translateFn('Policy settings changed using Power User'),
            tooltipText: translateFn('Policy settings were changed using Power User and remained active.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
        ],
      },
      {
        key: InsightsTemplatesStringKeys.ENDPOINT_COMMUNICATION_ISSUES,
        title: translateFn('Communication issues'),
        items: [
          {
            key: InsightsTemplatesStringKeys.CANNOT_CONNECT_TO_GPN,
            name: translateFn('Not connected to Bitdefender Global Protective Network'),
            tooltipText: translateFn(
              'Endpoints cannot establish communication with Bitdefender Global Protective Network.'
            ),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.ISOLATED,
            name: translateFn('Isolated'),
            tooltipText: translateFn('Endpoints are network restricted and communicate only with GravityZone.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
        ],
      },
      {
        key: InsightsTemplatesStringKeys.ENDPOINT_MODULE_ISSUES,
        title: translateFn('Modules issues'),
        items: [
          {
            key: InsightsTemplatesStringKeys.DISABLED_MODULES,
            name: translateFn('Modules disabled from the policy'),
            tooltipText: translateFn('Endpoints have protection modules disabled from the policy.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.MALFUNCTIONING_MODULES,
            name: translateFn('Malfunctioning modules'),
            tooltipText: translateFn(
              'Endpoints have protection modules installed and enabled but not operating properly.'
            ),
            severity: WidgetSectionItemSeverity.ERROR,
          },
          {
            key: InsightsTemplatesStringKeys.EXPIRED_MODULES,
            name: translateFn('Expired modules'),
            tooltipText: translateFn('Endpoints are unlicensed and protection modules have expired.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
          {
            key: InsightsTemplatesStringKeys.MODULES_IN_GRACE_PERIOD,
            name: translateFn('Modules about to expire'),
            tooltipText: translateFn(
              'Installed endpoints exceeding the license limit that are currently in a 30-day grace period.'
            ),
            severity: WidgetSectionItemSeverity.WARNING,
          },
        ],
      },
    ],
  };
}
